import { Badge } from "@fronterahealth/frontera-ui-components/ui/badge";

import { ReviewItemFieldsFragment } from "@api/graphql/types-and-hooks";
import { QUALITY_REVIEW_SOURCE } from "@components/QaReview/components/suggestionIcon";

export const SourceBadge: React.FC<{ comment: ReviewItemFieldsFragment }> = ({ comment }) => {
  if (comment.__typename === "ReportSuggestionType") {
    return (
      <Badge variant="outline" size="sm" className="shrink-0 bg-transparent text-blurple-600">
        {QUALITY_REVIEW_SOURCE}
      </Badge>
    );
  }
  if (comment.__typename === "ReportCommentType") {
    return (
      <Badge variant="outline" size="sm" className="shrink-0 bg-transparent text-emerald-700">
        Team Review
      </Badge>
    );
  }
  return null;
};
